<div class="maintenance-page">
  <div class="page-header">
    <div class="header-text">
      <h2>Solicitações de manutenção</h2>
      <p>
        Acompanhe e priorize as solicitações da frota. Clique em uma linha para
        abrir o detalhe.
      </p>
    </div>
    <div class="header-actions">
      <button nz-button nzType="default" (click)="clearAllFilters()">
        Limpar filtros
      </button>
      <button nz-button nzType="primary" (click)="exportToPdf()">
        <i nz-icon nzType="file-pdf"></i>
        Exportar PDF
      </button>
    </div>
  </div>

  <div class="metrics-grid">
    <button
      type="button"
      class="metric-card"
      [class.metric-card--active]="!hasStatusFilter"
      (click)="filterByStatus(null)"
    >
      <span class="metric-card__label">Total</span>
      <strong class="metric-card__value">{{ statusCounts.total }}</strong>
      <span class="metric-card__unit">solicitações</span>
    </button>
    <button
      type="button"
      class="metric-card metric-card--progress"
      [class.metric-card--active]="isStatusFilterActive('in_progress')"
      (click)="filterByStatus('in_progress')"
    >
      <span class="metric-card__label">Em andamento</span>
      <strong class="metric-card__value">{{ statusCounts.in_progress }}</strong>
      <span class="metric-card__unit">aguardando ação</span>
    </button>
    <button
      type="button"
      class="metric-card metric-card--done"
      [class.metric-card--active]="isStatusFilterActive('done')"
      (click)="filterByStatus('done')"
    >
      <span class="metric-card__label">Finalizadas</span>
      <strong class="metric-card__value">{{ statusCounts.done }}</strong>
      <span class="metric-card__unit">concluídas</span>
    </button>
    <button
      type="button"
      class="metric-card metric-card--canceled"
      [class.metric-card--active]="isStatusFilterActive('canceled')"
      (click)="filterByStatus('canceled')"
    >
      <span class="metric-card__label">Canceladas</span>
      <strong class="metric-card__value">{{ statusCounts.canceled }}</strong>
      <span class="metric-card__unit">encerradas</span>
    </button>
    <button
      type="button"
      class="metric-card metric-card--not-proceed"
      [class.metric-card--active]="isStatusFilterActive('not_proceed')"
      (click)="filterByStatus('not_proceed')"
    >
      <span class="metric-card__label">Não procede</span>
      <strong class="metric-card__value">{{ statusCounts.not_proceed }}</strong>
      <span class="metric-card__unit">indeferidas</span>
    </button>
  </div>

  @if (hasActiveFilters) {
    <div class="active-filters">
      <span class="active-filters__label">Filtros ativos</span>
      <button nz-button nzType="link" nzSize="small" (click)="clearAllFilters()">
        Remover todos
      </button>
    </div>
  }

  <div class="table-card">
    <div class="table-scroll">
      <nz-table
        #sortTable
        [nzData]="checklistHeaderFound"
        [nzLoading]="(checklistHeaderLoader | async) ?? false"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        nzSize="middle"
      >
        <thead>
          <tr>
            <th nzWidth="72px" nzCustomFilter>
              ID
              <nz-filter-trigger
                [nzActive]="!!filterConditions['id']"
                [nzDropdownMenu]="idMenu"
              >
                <i nz-icon nzType="filter" nzTheme="fill"></i>
              </nz-filter-trigger>
            </th>
            <th nzCustomFilter>
              Modelo
              <nz-filter-trigger
                [nzActive]="filterConditions['model']?.length > 0"
                [nzDropdownMenu]="modelMenu"
              >
                <i nz-icon nzType="filter" nzTheme="fill"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="120px" nzCustomFilter>
              Placa
              <nz-filter-trigger
                [nzActive]="filterConditions['chassis']?.length > 0"
                [nzDropdownMenu]="chassisMenu"
              >
                <i nz-icon nzType="filter" nzTheme="fill"></i>
              </nz-filter-trigger>
            </th>
            <th
              nzWidth="120px"
              [nzFilters]="statusFilters"
              (nzFilterChange)="onFilterChange('status', $event)"
            >
              Status
            </th>
            <th nzWidth="110px" nzCustomFilter>
              Data
              <nz-filter-trigger
                [nzActive]="filterConditions['date']?.length > 0"
                [nzDropdownMenu]="dateMenu"
              >
                <i nz-icon nzType="filter" nzTheme="fill"></i>
              </nz-filter-trigger>
            </th>
            <th nzCustomFilter>
              Solicitante
              <nz-filter-trigger
                [nzActive]="filterConditions['user']?.length > 0"
                [nzDropdownMenu]="userMenu"
              >
                <i nz-icon nzType="filter" nzTheme="fill"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="88px"></th>
          </tr>
        </thead>
        <tbody>
          @for (item of checklistHeaderFound; track item.id) {
            <tr class="clickable-row" (click)="handleOpenChecklistHeader(item.id)">
              <td>
                <span class="id-badge">#{{ item.id }}</span>
              </td>
              <td>
                <span class="model-name">
                  {{ $any(item.ProductModel)?.name || 'N/A' }}
                </span>
              </td>
              <td>
                <span class="plate-badge">
                  {{ item.chassis ? (item.chassis | uppercase) : 'N/A' }}
                </span>
              </td>
              <td>
                <nz-tag [nzColor]="setStatusColor(item.status).color">
                  {{ setStatusColor(item.status).text }}
                </nz-tag>
              </td>
              <td>{{ item.date | date: 'dd/MM/yyyy' }}</td>
              <td>{{ $any(item.UserModel)?.name || 'N/A' }}</td>
              <td>
                <span class="row-action">
                  Abrir
                  <i nz-icon nzType="right" nzTheme="outline"></i>
                </span>
              </td>
            </tr>
          }
        </tbody>
        <ng-template nzNoResult>
          <nz-empty
            class="list-empty"
            nzNotFoundImage="simple"
            [nzNotFoundContent]="
              hasActiveFilters
                ? 'Nenhuma solicitação encontrada com os filtros atuais'
                : 'Nenhuma solicitação de manutenção cadastrada'
            "
          ></nz-empty>
        </ng-template>
      </nz-table>
    </div>
  </div>

  @if (checklistHeaderTotal > 0) {
    <div class="table-footer">
      <span class="table-footer__summary">
        Exibindo {{ checklistHeaderFound.length }} de {{ checklistHeaderTotal }}
      </span>
      <nz-pagination
        #pager
        [nzPageIndex]="currentPage"
        [nzPageSize]="currentPageSize"
        (nzPageIndexChange)="onPageChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzTotal]="checklistHeaderTotal"
        nzResponsive="true"
        nzShowSizeChanger
      >
      </nz-pagination>
    </div>
  }
</div>

<nz-dropdown-menu #dateMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-panel">
      <nz-range-picker [(ngModel)]="filterConditions['date']"></nz-range-picker>
    </div>
    <div class="filter-panel filter-panel--actions">
      <button
        nz-button
        nzSize="small"
        nzType="primary"
        (click)="onFilterChange('date', filterConditions['date'])"
      >
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="onFilterChange('date', null)">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-panel">
      <input
        nz-input
        placeholder="Buscar solicitante"
        [(ngModel)]="userSearch"
        (ngModelChange)="onUserSearch($event)"
      />
    </div>
    <div class="filter-panel filter-panel--list">
      @for (filter of visibleUserFilters; track filter.value) {
        <label nz-checkbox [(ngModel)]="filter.checked">{{ filter.text }}</label>
      }
    </div>
    <div class="filter-panel filter-panel--actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyUserFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearUserFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #modelMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-panel">
      <input
        nz-input
        placeholder="Buscar modelo"
        [(ngModel)]="modelSearch"
        (ngModelChange)="onModelSearch($event)"
      />
    </div>
    <div class="filter-panel filter-panel--list">
      @for (filter of visibleModelFilters; track filter.value) {
        <label nz-checkbox [(ngModel)]="filter.checked">{{ filter.text }}</label>
      }
    </div>
    <div class="filter-panel filter-panel--actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyModelFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearModelFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #chassisMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-panel">
      <input
        nz-input
        placeholder="Buscar placa"
        [(ngModel)]="chassisSearch"
        (ngModelChange)="onChassisSearch($event)"
      />
    </div>
    <div class="filter-panel filter-panel--list">
      @for (filter of visibleChassisFilters; track filter.value) {
        <label nz-checkbox [(ngModel)]="filter.checked">{{ filter.text }}</label>
      }
    </div>
    <div class="filter-panel filter-panel--actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyChassisFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearChassisFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #idMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-panel">
      <input
        nz-input
        placeholder="Buscar ID"
        [(ngModel)]="idSearch"
        (ngModelChange)="onIdSearch($event)"
      />
    </div>
    <div class="filter-panel filter-panel--actions">
      <button
        nz-button
        nzSize="small"
        nzType="primary"
        (click)="onIdSearch(idSearch)"
      >
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearIdFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>
